import Vue from 'vue';
import VueRouter from 'vue-router';

const staticRoute = [
  {
    path: '/',
    component: () => import('../views/index'),
  },
  // {
  //   path: '/monitor',
  //   component: () => import('../views/monitor/index'),
  // },
  {
    path: '/monitor',
    component: () => import('../views/monitor/index2'),
    props: (route) => ({
      cityId: route.query.cityId,
      hospitalCode: route.query.hospitalCode,
      diyCityName: route.query.diyCityName,
      diyCarNo: route.query.diyCarNo,
      dtType: route.query.dtType,
      debug: route.query.debug,
    }),
  },
  {
    path: '/monitorOld',
    component: () => import('../views/monitor/index'),
  },
];

Vue.use(VueRouter);
// 以下代码解决路由地址重复的报错问题

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  routes: staticRoute,
});

export default router;
